import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined, Edit, FilterList, Info } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import {
  resetDetailSetoranHarian,
  resetPengeluaranSetoran,
  setMessage,
  setStatus,
} from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import {
  fetchChangeStatusSetoran,
  fetchDeleteSetoran,
  fetchEditCatatanSetoran,
  fetchListSetoran,
  fetchDetailSetoranPerhari,
  fetchPengeluaranSetoran,
  fetchGetPengeluaranSetoran,
  fetchGetPengeluaranSetoranGlobal,
  fetchSaveWarkat,
} from "state/setoranAction";
import formatRupiah from "utils/formatRupiah";
import DetailSetoranModal from "components/Modals/DetailSetoranModal";
import EditCatatanModal from "components/Modals/EditCatatanModal";
import DetailSetoranHarianModal from "components/Modals/DetailSetoranHarianModal";
import CustomFilterModal from "./CustomFilterModal";
import SortableHeader from "components/SortableHeader";
import DetailSetoranModalTransfer from "components/Modals/DetailSetoranModalTransfer";
import {
  fetchListPerkiraan,
  postListTransaksiWarkat,
} from "state/alokasiAction";
import { useNavigate } from "react-router-dom";
moment.locale("id");

const Setoran = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, message } = useSelector((state) => state.global);
  const {
    list_setoran,
    detail_setoran_harian,
    pengeluaran_setoran,
    pengeluaran_setoran_global,
  } = useSelector((state) => state.setoran);
  const { list_perkiraan } = useSelector((state) => state.alokasi);
  console.log("detail_setoran_harian", detail_setoran_harian);

  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openDetailTransfer, setOpenDetailTransfer] = useState(false);
  const [openEditCatatan, setOpenEditCatatan] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [showingDetail, setShowingDetail] = useState(false);

  const [filteredData, setFilteredData] = React.useState([]);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  useEffect(() => {
    dispatch(fetchListSetoran());
    dispatch(fetchListPerkiraan());
  }, []);

  useEffect(() => {
    if (list_setoran) {
      const filtered = applyCustomFilters(list_setoran, appliedFilters);
      setFilteredData(filtered);
    }
  }, [list_setoran, appliedFilters]);
  const handleApplyCustomFilter = (filters) => {
    setAppliedFilters(filters);
  };

  const applyCustomFilters = (data, filterConfig) => {
    if (!filterConfig || Object.keys(filterConfig).length === 0) return data;

    let result = [...data];

    if (filterConfig.dateRange) {
      const { tanggalAwal, tanggalAkhir } = filterConfig.dateRange;

      if (tanggalAwal || tanggalAkhir) {
        const startBoundary = tanggalAwal
          ? moment(tanggalAwal).startOf("day")
          : null;

        const endBoundary = tanggalAkhir
          ? moment(tanggalAkhir).endOf("day")
          : null;

        result = result.filter((row) => {
          if (!row.waktu_setoran) return false;

          const rowDate = moment(row.waktu_setoran, "YYYY-MM-DD");

          if (!rowDate.isValid()) {
            console.warn(
              `Invalid date format found for row: ${row.waktu_setoran}`,
            );
            return false;
          }

          const isAfterStart = startBoundary
            ? rowDate.isSameOrAfter(startBoundary)
            : true;

          const isBeforeEnd = endBoundary
            ? rowDate.isSameOrBefore(endBoundary)
            : true;

          return isAfterStart && isBeforeEnd;
        });
      }
    }

    if (filterConfig.filter) {
      if (
        filterConfig.filter.nama_cab &&
        filterConfig.filter.nama_cab.length > 0
      ) {
        result = result.filter((row) => {
          return filterConfig.filter.nama_cab.includes(row.nama_cab);
        });
      }

      if (
        filterConfig.filter.nama_karyawan &&
        filterConfig.filter.nama_karyawan.length > 0
      ) {
        result = result.filter((row) => {
          return filterConfig.filter.nama_karyawan.includes(row.nama_karyawan);
        });
      }

      if (filterConfig.filter.status) {
        const statusFilterValue = filterConfig.filter.status;

        result = result.filter((row) => {
          return row.status === statusFilterValue;
        });
      }
    }

    if (filterConfig.sort && filterConfig.sort.length > 0) {
      result.sort((a, b) => {
        for (let sortRule of filterConfig.sort) {
          let { column, order } = sortRule;
          let aValue = a[column];
          let bValue = b[column];

          if (aValue == null) return 1;
          if (bValue == null) return -1;

          if (typeof aValue === "string") aValue = aValue.toLowerCase();
          if (typeof bValue === "string") bValue = bValue.toLowerCase();

          if (aValue < bValue) return order === "asc" ? -1 : 1;
          if (aValue > bValue) return order === "asc" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  };

  const handleClearCustomFilter = () => {
    setAppliedFilters({});
    setFilteredData([]);
  };

  const getActiveFilterCount = useCallback(() => {
    let count = 0;

    if (appliedFilters.dateRange) {
      if (
        appliedFilters.dateRange.tanggalAwal ||
        appliedFilters.dateRange.tanggalAkhir
      ) {
        count++;
      }
    }

    if (appliedFilters.filter) {
      if (appliedFilters.filter.nama_cab?.length > 0) count++;
      if (appliedFilters.filter.nama_karyawan?.length > 0) count++;
      if (appliedFilters.filter.status?.length > 0) count++;
    }

    return count;
  }, [appliedFilters]);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListSetoran());
    setIsDelete(false);
  };

  const handleSelectedData = useCallback(
    (id) => {
      let currentSelectedData = list_setoran.find((item) => item.id === id);
      setSelectedData(currentSelectedData);
      dispatch(fetchGetPengeluaranSetoran(currentSelectedData));
    },
    [list_setoran, dispatch],
  );

  const handleSetujui = () => {
    dispatch(fetchChangeStatusSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleDelete = () => {
    dispatch(fetchDeleteSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleSubmitEditKaryawan = (value) => {
    dispatch(fetchEditCatatanSetoran(selectedData.id, value));
    setOpenEditCatatan(false);
    setSelectedData(null);
  };

  const formatStringToArrayPengeluaran = (
    inputString,
    tanggalAlokasi,
    tanggalSetoran,
  ) => {
    console.log("tanggalSetoran", tanggalSetoran);
    console.log("tanggalAlokasi", tanggalAlokasi);

    if (!inputString) return [];

    return inputString.split(";").map((item, index) => ({
      id: Date.now() + index,
      nama: item.split(":")[0].trim(),
      nominal: parseInt(item.split(":")[1].trim(), 10),
      kode_perkiraan: null,
      tipe: "pengeluaran",
      status: "alokasi",
      catatan: item.split(":")[0].trim(),
      tanggal_kas: moment(tanggalAlokasi).format(),
      tanggal_setoran: moment(tanggalSetoran).format(),
    }));
  };

  const handleSaveWarkat = async (value) => {
    console.log("value", value);

    try {
      if (pengeluaran_setoran_global?.list_pengeluaran) {
        const pengeluaranToAlokasi = formatStringToArrayPengeluaran(
          pengeluaran_setoran_global.list_pengeluaran,
          value.tanggal_kas,
          value.tanggal_setoran,
        );

        await dispatch(postListTransaksiWarkat(pengeluaranToAlokasi));
      }

      await dispatch(fetchSaveWarkat(value));

      setShowingDetail(false);
      setSelectedData(null);

      setTimeout(() => {
        navigate("/alokasidc");
      }, 3000);
    } catch (error) {
      console.error("Error saving warkat:", error);
      alert("Terjadi kesalahan saat menyimpan data. Silakan coba lagi.");
    }
  };

  const handleSubmitPengeluaran = (value, justApprove) => {
    if (!!justApprove) {
      handleSetujui();
    } else {
      if (!value.id) {
        handleSetujui();
      }
      dispatch(fetchPengeluaranSetoran(value));
    }
    setOpenDetail(false);
    setOpenDetailTransfer(false);
  };
  const renderStatusSetoran = (value) => {
    if (value == "disetujui") {
      return "Disetujui";
    } else {
      return "Belum Disetujui";
    }
  };

  const columnsSetoran = useMemo(
    () => [
      {
        name: "id",
        label: "ID",
        options: {
          display: false,
        },
      },
      {
        name: "nama_cab",
        label: "Setoran Toko",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "tgl_kas",
        label: "Waktu Sinkron",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const waktuSetoran = tableMeta.rowData[3];
            return (
              <a
                style={{ cursor: "pointer", color: "red" }}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(fetchDetailSetoranPerhari(value, waktuSetoran));
                  dispatch(fetchGetPengeluaranSetoranGlobal(value));
                  setShowingDetail(true);
                }}
              >
                {value === "-" ? "-" : moment(value).format("DD/MM/YYYY")}
              </a>
            );
          },
        },
      },
      {
        name: "waktu_setoran",
        label: "Waktu Setoran",
        options: {
          filter: true,
          sort: true,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const tglKas = tableMeta.rowData[2];
            return (
              <a
                style={{ cursor: "pointer", color: "red" }}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(fetchDetailSetoranPerhari(tglKas, value));
                  dispatch(fetchGetPengeluaranSetoranGlobal(tglKas));
                  setShowingDetail(true);
                }}
              >
                {value === "-" ? "-" : moment(value).format("DD/MM/YYYY")}
              </a>
            );
          },
        },
      },
      {
        name: "nominal_setoran",
        label: "Nominal Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => formatRupiah(value),
        },
      },
      {
        name: "nama_karyawan",
        label: "Nama Penyetor",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
        },
      },
      {
        name: "status",
        label: "Status Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => renderStatusSetoran(value),
        },
      },
      {
        name: "transfer",
        label: "Transfer",
        options: {
          display: false,
        },
      },
      {
        name: "tipe",
        label: "Tipe Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),

          customBodyRender: (value, tableMeta, updateValue) => {
            const transfer = tableMeta.rowData[7];
            if (transfer > 0) {
              return "Transfer";
            } else {
              return "Tunai";
            }
          },
        },
      },
      {
        name: "catatan",
        label: "Catatan Setoran",
        options: {
          filter: true,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value) => value || "-",
        },
      },
      {
        name: "aksi",
        label: "Aksi",
        options: {
          filter: false,
          sort: false,
          customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
            <SortableHeader
              key={`col-${columnMeta.index}`}
              label={columnMeta.label}
              columnName={columnMeta.name}
              sortOrder={sortOrder}
              onClick={() => handleToggleColumn(columnMeta.index)}
              sorting
            />
          ),
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0];
            const transfer = tableMeta.rowData[7];
            return (
              <>
                <IconButton
                  color="info"
                  onClick={() => {
                    handleSelectedData(id);
                    if (transfer > 0) {
                      setOpenDetailTransfer(true);
                    } else {
                      setOpenDetail(true);
                    }
                  }}
                >
                  <Info />
                </IconButton>
                <IconButton
                  color="info"
                  onClick={() => {
                    handleSelectedData(id);
                    setOpenEditCatatan(true);
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  color="warning"
                  onClick={() => {
                    handleSelectedData(id);
                    setIsDelete(true);
                    setOpenKonfirmasi(true);
                  }}
                >
                  <DeleteOutlined />
                </IconButton>
              </>
            );
          },
        },
      },
    ],
    [dispatch, handleSelectedData],
  );

  const options = useMemo(
    () => ({
      selectableRows: "none",
      filterType: "dropdown",
      filter: false,
      fixedHeader: false,
      fixedSelectColumn: false,
      search: true,
      viewColumns: false,
      responsive: "standard",
      customToolbar: () => {
        const activeCount = getActiveFilterCount();
        return (
          <Button
            startIcon={<FilterList />}
            onClick={() => setOpenCustomFilter(true)}
            variant={activeCount > 0 ? "contained" : "outlined"}
            size="small"
            color={activeCount > 0 ? "primary" : "inherit"}
            sx={{
              mr: 1,
              ...(activeCount === 0 && {
                color: "text.secondary",
                borderColor: "text.secondary",
              }),
            }}
          >
            Filter {activeCount > 0 && `(${activeCount})`}
          </Button>
        );
      },
      rowsPerPageOptions: [
        30,
        60,
        filteredData.length > 0 || Object.keys(appliedFilters).length > 0
          ? filteredData.length
          : list_setoran
            ? list_setoran.length
            : 0,
      ],
      rowsPerPage: rowsPerPage,
      onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
    }),
    [
      filteredData.length,
      list_setoran,
      appliedFilters,
      rowsPerPage,
      getActiveFilterCount,
    ],
  );

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Setoran" subtitle="Daftar Setoran dari setiap toko." />

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={
            filteredData.length > 0 || Object.keys(appliedFilters).length > 0
              ? filteredData
              : list_setoran
          }
          columns={columnsSetoran}
          options={options}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={isDelete ? "Hapus" : "Setujui"}
          subtitleType={isDelete ? "Menghapus" : "Menyetujui"}
          dataWillProses={"Setoran Ini"}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => (isDelete ? handleDelete() : handleSetujui())}
          textButtonPositif={isDelete ? "Hapus" : "Setujui"}
        />
        <EditCatatanModal
          open={openEditCatatan}
          dataEdit={selectedData}
          onClose={() => setOpenEditCatatan(false)}
          onSubmit={(value) => handleSubmitEditKaryawan(value)}
        />
        <DetailSetoranModal
          dataDetail={selectedData}
          dataPengeluaran={pengeluaran_setoran}
          listPerkiraan={list_perkiraan}
          open={openDetail}
          onClose={() => {
            setSelectedData(null);
            setOpenDetail(false);
          }}
          onSubmit={handleSubmitPengeluaran}
        />

        <DetailSetoranModalTransfer
          dataDetail={selectedData}
          dataPengeluaran={pengeluaran_setoran}
          open={openDetailTransfer}
          onClose={() => {
            setSelectedData(null);
            setOpenDetailTransfer(false);
          }}
          onSubmit={handleSubmitPengeluaran}
        />

        <DetailSetoranHarianModal
          dataDetail={detail_setoran_harian}
          dataPengeluaran={pengeluaran_setoran_global}
          open={showingDetail && detail_setoran_harian}
          onClose={() => {
            dispatch(resetDetailSetoranHarian());
            dispatch(resetPengeluaranSetoran());
            setShowingDetail(false);
          }}
          onSaveWarkat={handleSaveWarkat}
        />
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_setoran}
        />
      </Box>
    </Box>
  );
};

export default Setoran;
